/** @flow */
import * as React from 'react';
import moment from 'moment';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import DashboardPrintingMonthlyMetricsCard from './DashboardPrintingMonthlyMetricsCard';
import { hourlyMetricsType } from '../domain/DashboardData';
import WeekMetricPrintingElement from './components/WeekMetricPrintingElement';
import type { MonthlyDashboardData } from '../domain/DashboardData';

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const Content = styled.div`
  margin-top: 0px;
`;

const WeekMetricPrintingCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  max-height: 320px;
`;


type Props = {
  data: ?MonthlyDashboardData,
  from: moment,
  to: moment,
  theme: any;
  t: any,
  type: hourlyMetricsType,
};

class weeklyDashboardPrinting extends React.Component<Props> {
  render() {
    const { data, t, from, to, theme, type } = this.props;

    if (!data) {
      return null;
    }
    const overviewMetrics = {
      reach: data.averageReach,
      listeningTime: data.averageListeningTime,
      listeningTimePerPerson: data.averageListeningTimePerPerson,
    };
    const cumulativeMetrics = {
      reach: data.cumulativeReach,
      listeningTime: data.cumulativeListeningTime,
      listeningTimePerPerson: data.cumulativeListeningTimePerPerson,
    };

    return (
      <React.Fragment>
        <Header>
          <Title style={{ ...theme.fonts.style.sub, fontWeight: 'bold' }}>
            {t('date.text', { value: moment(from) })} - {t('date.text', { value: moment(to) })}
          </Title>
        </Header>
        <Content>
          <DashboardPrintingMonthlyMetricsCard cumulativeMetrics={cumulativeMetrics} averageMetrics={overviewMetrics} />
          <WeekMetricPrintingCard>
            <WeekMetricPrintingElement
              data={data}
              type={type}
            />
          </WeekMetricPrintingCard>
        </Content>
      </React.Fragment>
    );
  }
}

export default withTheme(translate()(weeklyDashboardPrinting));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/MonthlyDashboardPrinting.js